var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientCategory)?_c('span',{staticClass:"client-category",class:_vm.clientCategoryClass,domProps:{"textContent":_vm._s(_vm.clientCategory)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }